import { Box, Hidden } from '@material-ui/core';
import React from 'react';
import { CAIRNS_LOGO_IMAGE_URL } from 'assets/images/images';
import style from './AccountMobileHeader.scss';

export const AccountMobileHeader: React.FC = () => (
  /* @ts-expect-error: TODO add description */
  <Hidden mdUp>
    <Box className={style.mobileHeader}>
      <img className={style.titleBox} src={CAIRNS_LOGO_IMAGE_URL} alt="Cairns Health" />
    </Box>
  </Hidden>
);
